import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import {i18n} from './plugins/i18n'
import 'animate.css'
import 'fullpage-vue/src/fullpage.css'
import VueFullpage from 'fullpage-vue'

Vue.config.productionTip = false

Vue.use(VueFullpage)

new Vue({
  router,
  vuetify,
  i18n,
  render: function (h) {
    return h(App)
  }
}).$mount('#app')

import './assets/scss/style.scss';